import { useRef, useState } from "react";
import { POSTS, SITE } from "@/mocks/gossip";

const SUBMIT = "https://readdy.ai/api/form/daemaqhtto0ceqqngvvg";

const stats = [
  { n: "58亿+", l: "累计围观热度" },
  { n: "1.2w+", l: "已发布速递" },
  { n: "6 大", l: "常设热门栏目" },
  { n: "24h", l: "滚动更新不断档" },
];

export default function AboutContact() {
  const [status, setStatus] = useState<"idle" | "sending" | "ok" | "err">("idle");
  const [msg, setMsg] = useState("");
  const formRef = useRef<HTMLFormElement>(null);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = (fd.get("company_alt") as string) || "";
    const params = new URLSearchParams();
    fd.forEach((v, k) => {
      if (k !== "company_alt") params.append(k, v as string);
    });
    if (honeypot.trim()) {
      setStatus("ok");
      form.reset();
      setTimeout(() => setStatus("idle"), 3000);
      return;
    }
    if (!params.get("email")) {
      setMsg("请填写你的联系方式，方便我们跟进你的投稿。");
      setStatus("err");
      return;
    }
    setStatus("sending");
    try {
      const res = await fetch(SUBMIT, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });
      const text = await res.text();
      const parsed = text ? JSON.parse(text) : {};
      const serverMsg = parsed?.meta?.message || parsed?.message || "";
      if (res.ok && parsed?.code === "OK" && !/spam/i.test(serverMsg)) {
        setStatus("ok");
        form.reset();
        setTimeout(() => setStatus("idle"), 3500);
      } else {
        setStatus("err");
        setMsg(serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("err");
      setMsg("网络异常，请稍后重试。");
    }
  };

  const sample = POSTS[0];

  return (
    <section id="contact" className="scroll-mt-24 mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start">
        {/* 关于我们 */}
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-secondary-600 bg-secondary-100 rounded-full px-3 py-1 mb-3">
            <i className="ri-team-line"></i> 关于九一吃瓜
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            我们是谁
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            九一吃瓜是一个专注热门事件与新瓜速递的资讯围观站。我们相信，真正有价值的热点不止于热闹，更在于把它讲清楚、看明白。于是我们组建起一支"现场优先、理性围观"的内容团队。
          </p>

          <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.l} className="rounded-2xl border border-secondary-200 bg-secondary-50 p-4 text-center">
                <div className="font-heading text-2xl text-secondary-700">{s.n}</div>
                <div className="text-xs text-foreground-500 mt-1">{s.l}</div>
              </div>
            ))}
          </div>

          {/* 内容原则 */}
          <div className="mt-6 rounded-3xl border border-background-200 bg-background-50 p-5 md:p-6">
            <h3 className="text-base font-bold text-foreground-900 mb-4">我们的内容原则</h3>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex gap-3">
                <span className="w-6 h-6 shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600"><i className="ri-check-line"></i></span>
                <span><strong className="text-foreground-800">现场优先：</strong>尽量引用可核实的公开画面与一手信息，重大事件优先跟进。</span>
              </li>
              <li className="flex gap-3">
                <span className="w-6 h-6 shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-600"><i className="ri-check-line"></i></span>
                <span><strong className="text-foreground-800">多方求证：</strong>不捕风捉影，对存疑内容明确标注，用审慎态度对待每一条瓜。</span>
              </li>
              <li className="flex gap-3">
                <span className="w-6 h-6 shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600"><i className="ri-check-line"></i></span>
                <span><strong className="text-foreground-800">有分寸的围观：</strong>尊重当事人隐私与权益，不传播恶意揣测，不做网暴推手。</span>
              </li>
            </ul>
          </div>

          {/* 用户口碑 */}
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              { q: "更新快、角度新，早上醒来第一件事就是刷一遍九一的今日速递。", n: "前排老观众", c: "primary" },
              { q: "最喜欢他们把事件来龙去脉讲清楚，吃瓜也能吃出信息增量。", n: "理性围观派", c: "accent" },
              { q: "理性、克制又不失温度，是难得愿意长期关注的围观站。", n: "社区老粉", c: "secondary" },
            ].map((t, i) => (
              <div
                key={i}
                className={`rounded-2xl border ${
                  t.c === "primary" ? "border-primary-100 bg-primary-50" : t.c === "accent" ? "border-accent-200 bg-accent-50" : "border-secondary-200 bg-secondary-50"
                } p-5 ${i === 2 ? "sm:col-span-2" : ""}`}
              >
                <div className="flex gap-1 text-accent-500 mb-2 text-sm">
                  <i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i><i className="ri-star-fill"></i>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">“{t.q}”</p>
                <p className="mt-3 text-xs font-medium text-foreground-500">{t.n}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 联系 / 投稿表单 */}
        <div className="lg:col-span-5 lg:sticky lg:top-24">
          <div className="rounded-3xl border border-primary-100 bg-gradient-to-br from-background-50 to-primary-50 p-6 md:p-7">
            <div className="flex items-center gap-3 mb-2">
              <span className="w-11 h-11 flex items-center justify-center rounded-2xl bg-primary-500 text-background-50">
                <i className="ri-megaphone-line text-xl"></i>
              </span>
              <div>
                <h2 className="text-xl font-bold text-foreground-950">前排投稿 / 联系我们</h2>
              </div>
            </div>
            <p className="text-sm text-foreground-600 mb-6">
              拍到了有意思的现场？发现新鲜话题？欢迎投稿。也欢迎你就任何话题和我们聊聊。
            </p>

            <form ref={formRef} onSubmit={onSubmit} data-readdy-form className="space-y-4">
              <div className="field-safety">
                <label htmlFor="alt-company-c">公司</label>
                <input id="alt-company-c" type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">怎么称呼你</label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  required
                  placeholder="昵称或称呼"
                  className="w-full rounded-xl border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-800 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">联系邮箱</label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  required
                  placeholder="name@example.com"
                  className="w-full rounded-xl border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-800 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition"
                />
              </div>
              <div>
                <label htmlFor="contact-topic" className="block text-sm font-medium text-foreground-800 mb-1.5">投稿类型</label>
                <select
                  id="contact-topic"
                  name="topic"
                  defaultValue="娱乐现场"
                  className="w-full rounded-xl border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-800 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition"
                >
                  <option>娱乐现场</option>
                  <option>综艺热点</option>
                  <option>剧集热议</option>
                  <option>社会视点</option>
                  <option>乐坛趣闻</option>
                  <option>其他话题</option>
                </select>
              </div>
              <div>
                <label htmlFor="contact-msg" className="block text-sm font-medium text-foreground-800 mb-1.5">内容 / 留言</label>
                <textarea
                  id="contact-msg"
                  name="message"
                  required
                  rows={4}
                  maxLength={500}
                  placeholder="简要描述你拍到或想聊的现场内容…"
                  className="w-full rounded-xl border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-800 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition resize-none"
                ></textarea>
              </div>

              <button
                type="submit"
                disabled={status === "sending"}
                className="w-full rounded-full bg-primary-500 text-background-50 text-sm font-medium py-3 hover:bg-primary-600 disabled:opacity-60 transition whitespace-nowrap"
              >
                {status === "sending"
                  ? "提交中…"
                  : status === "ok"
                  ? "已收到，感谢前排围观"
                  : "提交投稿 / 留言"}
              </button>
              {status === "err" && msg && (
                <p className="text-xs text-primary-600">{msg}</p>
              )}
              <p className="text-[11px] text-foreground-400 leading-relaxed text-center">
                提交即表示你同意我们仅在处理本投稿时使用你的联系方式。放心，内容经过审核才会发布。
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}